module.exports = __webpack_public_path__ + "static/media/page4-right.0a851925.png";